// extracted by mini-css-extract-plugin
module.exports = {"root":"Media-module--root--3Ltpx","figure":"Media-module--figure--2Q5jN","body":"Media-module--body--1PBJ5"};